import { EntityFilesPanel } from "@/components/files/EntityFilesPanel";

export function PatientArquivosTab({ patientId }: { patientId: string }) {
  return <EntityFilesPanel relatedType="PATIENT" relatedId={patientId} />;
}
